import * as React from "react";
import { useTranslation } from "react-i18next";
import { signInWithCustomToken, signOut } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { auth, functions } from "../config/firebase";
import { usePostHog } from "posthog-js/react";

interface ImpersonationBannerProps {
  email: string | null;
}

export const ImpersonationBanner: React.FC<ImpersonationBannerProps> = ({
  email,
}) => {
  const { t } = useTranslation();
  const posthog = usePostHog();
  const [ending, setEnding] = React.useState(false);

  const handleEndImpersonation = async () => {
    setEnding(true);
    posthog?.reset();

    try {
      const endImpersonation = httpsCallable<void, { customToken: string }>(
        functions,
        "endImpersonation"
      );
      const res = await endImpersonation();
      await signInWithCustomToken(auth, res.data.customToken);
      window.location.href = "/";
    } catch (err) {
      console.error("Failed to restore support session:", err);
      await signOut(auth);
      window.location.href = "/";
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] flex items-center justify-center gap-4 bg-amber-500 px-4 py-1 text-xs font-medium text-white">
      <span>
        {t("support.impersonating")}: {email ?? "—"}
      </span>
      <button
        onClick={handleEndImpersonation}
        disabled={ending}
        className="rounded-lg bg-white/20 px-3 py-1 text-xs font-semibold hover:bg-white/30 transition-colors disabled:opacity-50"
      >
        {t("support.endSession")}
      </button>
    </div>
  );
};
